import { Command, CommandGroup, CommandItem, CommandList } from 'app/components/ui/command'
import { PickerButton } from './PickerButton'

export type PickerOption = { label: string; value: string }

/** A short fixed list, such as lead status or channel. */
export function OptionPicker({
  label,
  options,
  onChange,
}: {
  label: string
  options: PickerOption[]
  onChange: (value: string) => void
}) {
  return (
    <PickerButton label={label}>
      {(close) => (
        <Command className="bg-surface">
          <CommandList>
            <CommandGroup>
              {options.map((option) => (
                <CommandItem
                  key={option.value}
                  value={option.label}
                  onSelect={() => {
                    onChange(option.value)
                    close()
                  }}
                >
                  {option.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      )}
    </PickerButton>
  )
}
